import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';
import { Section, Input, Button, Card } from '../components/ui';
import Header from './Header';
import Footer from './Footer';
import './Login.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { login, resetPassword } = useAuth();
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e?.preventDefault();
        setIsLoading(true);
        setError('');
        try {
            await login(email, password);
            navigate('/dashboard');
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handlePasswordReset = async () => {
        if (!email) {
            setError('Please enter your email address first.');
            return;
        }
        setIsLoading(true);
        setError('');
        try {
            await resetPassword(email);
            setError('');
            alert('Password reset email sent! Please check your inbox.');
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-page-wrapper">
            <Header variant="minimal" />
            <Section variant="large" className="auth-section">
                <div className="auth-container">
                    <motion.div
                        className="auth-header"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <h1 className="auth-title">Log in</h1>
                        <p className="auth-subtitle">Welcome back! Sign in to continue.</p>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                    >
                        <Card variant="glass" className="auth-card">
                            <form className="auth-form" onSubmit={handleLogin}>
                                <Input
                                    type="email"
                                    name="email"
                                    label="Email"
                                    placeholder="your.email@example.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />

                                <Input
                                    type="password"
                                    name="password"
                                    label="Password"
                                    placeholder="Enter your password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />

                                {error && (
                                    <motion.div
                                        className="auth-error"
                                        initial={{ opacity: 0, y: -10 }}
                                        animate={{ opacity: 1, y: 0 }}
                                    >
                                        {error}
                                    </motion.div>
                                )}

                                <Button
                                    type="submit"
                                    variant="primary"
                                    size="lg"
                                    disabled={isLoading}
                                    className="auth-submit-button"
                                >
                                    {isLoading ? 'Signing in...' : 'Log in'}
                                </Button>

                                <button
                                    type="button"
                                    onClick={handlePasswordReset}
                                    className="auth-link-button"
                                    disabled={isLoading}
                                >
                                    Forgot Password?
                                </button>
                            </form>
                        </Card>

                        <div className="auth-footer-link">
                            <span className="auth-footer-text">Don't have an account? </span>
                            <Link to="/signup" className="auth-link">
                                Sign up
                            </Link>
                        </div>
                    </motion.div>
                </div>
            </Section>
            <Footer />
        </div>
    );
};

export default Login;